import { GLBModel } from "@/scene/GLBModel";
import type { EnvironmentDecorItemConfig } from "@/scene/SceneProps";
import {
  CORAL_MODELS,
  ROCK_FORMAT2_MODEL,
  ROCK_MODEL,
} from "./shared";
import { UnderwaterVisualSettingsOverride } from "@/scene/VisualSettings";

// Голубой хирург (#67) — Крем от загара, очки, чипсы
export const BLUETANG_GARBAGE_MODELS = [
  new GLBModel("/models/garbage/tube.glb"),
  new GLBModel("/models/garbage/glass_02.glb"),
  new GLBModel("/models/garbage/chips.glb"),
];

export const BLUETANG_ENVIRONMENT_DECOR: EnvironmentDecorItemConfig[] = [
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: -1.65, y: -2.28, z: -1.15 },
    rotation: { x: 0, y: 0.42, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.58,
    position: { x: 1.65, y: -2.28, z: -0.9 },
    rotation: { x: 0, y: -0.7, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.52,
    position: { x: 0.88, y: -2.29, z: 1.18 },
    rotation: { x: 0, y: 2.35, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.44,
    position: { x: -1.05, y: -2.3, z: 1.02 },
    rotation: { x: 0, y: 1.65, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CORAL_MODELS[4],
    targetSize: 0.7,
    position: { x: -2.4, y: -2.28, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2, y: 4.35, z: 1.95 },
  },
  {
    model: CORAL_MODELS[6],
    targetSize: 0.7,
    position: { x: -2.9, y: -2.45, z: -2.85 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.95, y: 2.55, z: 1 },
  },
  {
    model: CORAL_MODELS[7],
    targetSize: 0.7,
    position: { x: -1.35, y: -2, z: -3.2 },
    rotation: { x: 0, y: -1.396, z: 0 },
    scale: { x: 3, y: 9.2, z: 2.45 },
  },
  {
    model: CORAL_MODELS[7],
    targetSize: 0.7,
    position: { x: -4.75, y: -3.05, z: -3.02 },
    rotation: { x: 0, y: -1.396, z: 0 },
    scale: { x: 3, y: 9.2, z: 2.45 },
  },
  {
    model: CORAL_MODELS[7],
    targetSize: 0.7,
    position: { x: -0.15, y: -2, z: -3.02 },
    rotation: { x: 0, y: -0.262, z: 0 },
    scale: { x: 2.6, y: 6.8, z: 2.45 },
  },
  {
    model: CORAL_MODELS[7],
    targetSize: 0.7,
    position: { x: -0.9, y: -2.45, z: -1.95 },
    rotation: { x: 0, y: -0.262, z: 0 },
    scale: { x: 1.4, y: 4, z: 1.1 },
  },
  {
    model: CORAL_MODELS[8],
    targetSize: 0.7,
    position: { x: 2.4, y: -2.28, z: -2.75 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.5, y: 9.45, z: 1.15 },
  },
  {
    model: CORAL_MODELS[9],
    targetSize: 0.7,
    position: { x: 3.2, y: -2.6, z: -1.25 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 4.25, y: 5, z: 1.6 },
  },
  {
    model: CORAL_MODELS[9],
    targetSize: 0.7,
    position: { x: 4.15, y: -2.45, z: 0.35 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 4.25, y: 7.95, z: 4.5 },
  },
  {
    model: CORAL_MODELS[9],
    targetSize: 0.7,
    position: { x: -1.9, y: -2.5, z: -2.2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.95, y: 3.15, z: 1.75 },
  },
  {
    model: CORAL_MODELS[9],
    targetSize: 0.7,
    position: { x: -4.05, y: -2.8, z: -5.6 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.95, y: 3.15, z: 1.75 },
  },
  {
    model: CORAL_MODELS[10],
    targetSize: 0.7,
    position: { x: 0, y: -2.28, z: -2.1 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CORAL_MODELS[10],
    targetSize: 0.7,
    position: { x: 1.55, y: -2.28, z: -2.95 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.95, y: 2.1, z: 2.3 },
  },
  {
    model: CORAL_MODELS[10],
    targetSize: 0.7,
    position: { x: -3.1, y: -2.28, z: -1.45 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.95, y: 2.1, z: 2.3 },
  },
  {
    model: CORAL_MODELS[11],
    targetSize: 0.7,
    position: { x: -3.55, y: -2.28, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CORAL_MODELS[11],
    targetSize: 0.7,
    position: { x: 2.75, y: -2.28, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.6, y: 2.1, z: 1.75 },
  },
  {
    model: CORAL_MODELS[12],
    targetSize: 0.7,
    position: { x: 1.4, y: -2.28, z: 0 },
    rotation: { x: 3.142, y: -0.698, z: 3.142 },
    scale: { x: 1.65, y: 3.8, z: 1.75 },
  },
];

export const BLUETANG_VISUAL_SETTINGS: UnderwaterVisualSettingsOverride = {
  pollutionColor: "#827f65",
};